import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { createStyles, Grid, makeStyles } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-enterprise";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

type Props = EditableCallbackParams;

const useStyles = makeStyles((theme) =>
	createStyles({
		input: {
			"&:focus::placeholder": {
				color: "transparent !important",
			},
		},
	}),
);
export const LOTONumberColumn = ({ data }: Props) => {
	const classes = useStyles();
	const [searchParams] = useSearchParams();

	const {
		state: { LOTONumberToLink },
		actions: { setLOTONumberToLink },
	} = useAssetDetailsContext();

	const handleChangeLOTONumberChange = (e: any) => {
		setLOTONumberToLink(e.target.value.toUpperCase());
	};

	useEffect(() => {
		setLOTONumberToLink("");
	}, [searchParams]);

	if (data.id === -1) {
		return (
			<Grid
				container
				style={{
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
			>
				<input
					style={{
						outline: "none",
						border: "none",
						lineBreak: "auto",
						textAlign: "center",
						width: 148,
						maxWidth: 148,
						marginRight: "10px",
					}}
					value={LOTONumberToLink}
					onChange={handleChangeLOTONumberChange}
					placeholder={"Put a Number"}
					className={classes.input}
					autoFocus
					autoComplete="false"
				/>
			</Grid>
		);
	} else return data?.LOTONumber;
};
